export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" id="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <p className="name">The Reve Foundation</p>
          <p className="line">
            Thoughtful philanthropy.
            <br />
            <em className="accent">Meaningful impact.</em>
          </p>
        </div>

        <div className="footer-col">
          <h3>Contact</h3>
          <p>
            <a href="mailto:sherri@therevefoundation.com">sherri@therevefoundation.com</a>
          </p>
          <p style={{ marginTop: 8 }}>
            <a
              href="https://www.google.com/maps/search/?api=1&query=550+Hamilton+Ave,+Palo+Alto,+CA+94301,+United+States"
              target="_blank"
              rel="noopener noreferrer"
            >
              550 Hamilton Ave
              <br />
              Palo Alto, CA 94301
              <br />
              United States
            </a>
          </p>
        </div>

        <div className="footer-col">
          <h3>Explore</h3>
          <a className="foot-link" href="#mission">
            Our Mission
          </a>
          <a className="foot-link" href="#approach">
            Our Approach
          </a>
          <a className="foot-link" href="#contact">
            Contact Us
          </a>
          <a className="foot-link" href="#faq">
            Common Questions
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} The Reve Foundation. All rights reserved.</span>
        <span>Palo Alto, California</span>
      </div>
    </footer>
  );
}